import React from 'react'
import AuthHeader from '../../components/Navbar/AuthHeader'
import { useNavigate } from 'react-router-dom'
import successImg from '../../assets/img/icon/success_gif.gif'

function Success() {
    const navigate = useNavigate();
    const handleSubmit = (e) => {
        e.preventDefault()
        navigate('/login');
    }
    return (
        <div style={{background: '#13053A',minHeight: '100vh'}}>
            <AuthHeader />
            <div className="auth__container padding__tb__30">
                <div className='auth__container__box'>
                    <h3>Congratulations!</h3>
                    <p className='success-page auth__text'>You're all set! You can now log in to your account.</p>
                    <div className='auth__container__form w-full'>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-lg-12 text-center">
                                    <img src={successImg} className='img-fluid' alt="" style={{ maxHeight: '225px', }} />
                                </div>
                            </div>
                            <div className='form__group mb-5'>
                                <button type='submit' className='btn btn__block'>Proceed to Login</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Success